import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import './ConfirmationModalStyle.scss';

type Props = {
  isOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  okButtonText?: string;
  okButtonIcon?: string;
  cancelButtonText?: string;
  cancelButtonIcon?: string;
  title?: string;
  description?: string;
  okButtonStyle?: React.CSSProperties;
  cancelButtonStyle?: React.CSSProperties,
  isOkButtonLoading?: boolean
};

function ConfirmationModal(props: Props) {
  const {
    isOpen,
    onOk,
    onCancel,
    okButtonStyle = {},
    okButtonIcon,
    cancelButtonStyle = {},
    cancelButtonIcon,
    okButtonText = 'Yes',
    cancelButtonText = 'Cancel',
    title = 'Confirmation',
    description = 'Do you proceed?',
    isOkButtonLoading = false,

  } = props;

  return (
    <div className="confirmation_modal_container">
      <Dialog
        open={isOpen}
        maxWidth="xl"
        onClose={onCancel}
        aria-labelledby="alert-dialog-confirmation"
        aria-describedby="alert-dialog-confirmation-description"
      >
        <DialogTitle className="dialog_title" id="alert-dialog-confirmation">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-confirmation-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ paddingBottom: '18px' }}>
          <Button className="cancel_btn" style={cancelButtonStyle} onClick={onCancel}>
            {cancelButtonIcon && <img src={cancelButtonIcon} alt="cancel" />}
            {cancelButtonText}
          </Button>
          <Button className="ok_btn" onClick={onOk} autoFocus style={okButtonStyle} disabled={isOkButtonLoading}>
            {isOkButtonLoading ? (
              <div
                className="loading-spinner button-spin-loader"
              >
                <div className="spinner" />
              </div>
            ) : (
              <>
                {okButtonIcon && <img src={okButtonIcon} alt="delete" />}
                {okButtonText}
              </>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ConfirmationModal;
